import { useCallback } from 'react';
import { useUserIdSelector } from '~/store/userData/userData.selectors';
import { openBookDemo } from './bookDemo.helpers';

export const useBookDemo = () => {
  const userId = useUserIdSelector();

  return useCallback(() => {
    openBookDemo(userId || -1);
  }, [userId]);
};
